<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - 安卓清理大师
        </div>
        <product-menu now="supercleaner" />
        <div class="v100 bigimg mt20">
            <img alt="安卓清理大师" src="@/assets/images/supercleaner_banner.png" />
            <div class="brand">
				<img src="@/assets/images/azqlds.jpg" alt="安卓清理大师" height="75" width="121" />
			</div>
            <h1 style="display: block; position: absolute; left: -5999px">安卓清理大师</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="安卓清理大师，垃圾清理" class="fl" src="@/assets/images/supercleaner_fea1.jpg">
                <dt class="fr">垃圾清理</dt>
                <dd class="fr">一键清理手机系统运行垃圾，从此让您的手机告别卡顿、反应慢等情况。</dd>
            </dl>
            <dl>
                <img alt="安卓清理大师，提升手机启动和运行速度" class="fr" src="@/assets/images/supercleaner_fea3.jpg" />
                <dt class="fl">开机加速</dt>
                <dd class="fl">清理各种软件开机自启动，让您的手机飞一般运行！</dd>
            </dl>
            <dl>
                <img alt="安卓清理大师，内置软件轻松卸载" class="fl" src="@/assets/images/supercleaner_fea2.jpg" />
                <dt class="fr">卸载内置</dt>
                <dd class="fr">卸载那些烦人的系统预装软件，为您的手机腾出更多内存与空间，专业精准！</dd>
            </dl>
            <dl>
                <img alt="安卓清理大师，隐私保护更安心" class="fr" src="@/assets/images/supercleaner_fea4.jpg" />
                <dt class="fl">隐私保护</dt>
                <dd class="fl">强力保护您的隐私，让他人无法窥探你的小秘密！</dd>
            </dl>
        </div>
    </div>
</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "supercleaner",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/supercleaner.vue